import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';

import AppConstants from '../AppConstants';
const cacheBuster = AppConstants.APP_VERSION.split('.')
  .reverse()
  .join('');

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    debug: false,
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/Locales/{{lng}}/{{ns}}.json?v=${cacheBuster}`
    },
    fallbackLng: 'en',
    lng: 'en',
    load: 'current',
    interpolation: {
      escapeValue: false
    },
    react: {
      wait: true
    }
  });
export default i18n;



// WEBPACK FOOTER //
// ./src/Utils/i18n.js